export enum WithdrawCertificatePermissionErrorCode {
  WITHDRAW_CERTIFICATE_ACCESS_CONSUMER_HAS_ALREADY_RETRIEVED = 'WITHDRAW_CERTIFICATE_ACCESS_CONSUMER_HAS_ALREADY_RETRIEVED',
  WITHDRAW_CERTIFICATE_ACCESS_PERMISSION_NOT_FOUND = 'WITHDRAW_CERTIFICATE_ACCESS_PERMISSION_NOT_FOUND',
}

export const WithdrawCertificatePermissionErrorCodeTranslationKeyMap = {
  [WithdrawCertificatePermissionErrorCode.WITHDRAW_CERTIFICATE_ACCESS_CONSUMER_HAS_ALREADY_RETRIEVED]:
    'consumerHasAlreadyRetrieved',
  [WithdrawCertificatePermissionErrorCode.WITHDRAW_CERTIFICATE_ACCESS_PERMISSION_NOT_FOUND]:
    'permissionNotFound',
};
